export const FEDERATION_SPARQL_ENDPOINT =
  "https://apps.okn.us/federation/sparql";
